var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FFF7ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 21.3335V10.6668C18.6663 10.3132 18.5259 9.97407 18.2758 9.72402C18.0258 9.47397 17.6866 9.3335 17.333 9.3335H14.6663C14.3127 9.3335 13.9736 9.47397 13.7235 9.72402C13.4735 9.97407 13.333 10.3132 13.333 10.6668V21.3335",
    stroke: "#F54900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 12H10.6663C9.92996 12 9.33301 12.597 9.33301 13.3333V20C9.33301 20.7364 9.92996 21.3333 10.6663 21.3333H21.333C22.0694 21.3333 22.6663 20.7364 22.6663 20V13.3333C22.6663 12.597 22.0694 12 21.333 12Z",
    stroke: "#F54900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupation);
export default __webpack_public_path__ + "static/media/occupation.c51d52feca01266a6c43c0f8a2edd42e.svg";
export { ForwardRef as ReactComponent };